import { Button, Typography } from '@mui/material';
import { AdventCalendarEntry } from './types';
import CouponCode from './components/CouponCode';

import './components/PresentDialog.css';

import img_meme_001 from './media/meme_001.jpg';
import img_meme_002 from './media/meme_002.jpg';
import img_meme_003 from './media/meme_003.jpg';
import img_meme_004 from './media/meme_004.jpg';

import img_blog_001 from './media/blog_001.jpg';
import img_blog_002 from './media/blog_002.jpg';
import img_blog_003 from './media/blog_003.jpg';

import img_nototyp from './media/nototyp.jpg';
import img_synesthesia from './media/synesthesia.png';

import img_penguin from './media/penguin.png';
import img_menorah from './media/menorah.png';
import img_bear from './media/bear.png';
import img_sock from './media/sock.png';
import img_deer from './media/deer.png';
import img_ginger_bread_house from './media/ginger_bread_house.png';
import img_santa_002 from './media/santa_002.png';
import img_santa_003 from './media/santa_003.png';
import img_santa_004 from './media/santa_004.png';
import img_santa_010 from './media/santa_010.png';
import img_santa_011 from './media/santa_011.png';
import img_santa_012 from './media/santa_012.png';
import img_santa_014 from './media/santa_014.png';
import img_santa_015 from './media/santa_015.png';
import img_santa_018 from './media/santa_018.png';
import img_santa_019 from './media/santa_019.png';
import img_santa_020 from './media/santa_020.png';
import img_santa_021 from './media/santa_021.png';
import img_santa_022 from './media/santa_022.png';
import img_santa_025 from './media/santa_025.png';
import img_santa_026 from './media/santa_026.png';
import img_santa_027 from './media/santa_027.png';
import img_santa_029 from './media/santa_029.png';

import p2n_icon from "./media/p2n_icon.png";
import g2t_icon from "./media/g2t_icon.png";
import s2n_icon from "./media/s2n_icon.png";
import ms_icon from "./media/ms_icon.png";
import klangio_icon from "./media/Klangio-Logo-icon-1C.png"

import img_s2n_screenshot from "./media/freeday_s2n_screenshot.jpg";
import img_g2t_screenshot from "./media/freeday_g2t_screenshot.jpg";
import img_p2n_screenshot from "./media/freeday_p2n_screenshot.jpg";
import { isEuroCountry } from './utils';

import img_giftcards_1 from "./media/gift_cards_available.jpg";
import img_giftcards_2 from "./media/gift_cards_sale.jpg";
import img_bell_soundfont from "./media/07_bell_soundfont.jpg";
import img_sharing from "./media/12_sharing.jpg";
import img_d2n_launch from "./media/15_D2N_beta.jpg";
import img_sharing_2 from "./media/19_sharing.jpg";
import img_21_zahlen from "./media/21_zahlen.png";
import img_22_zahlen from "./media/22_zahlen.png";
import img_23_discount from "./media/23_DISCOUNT.png";

export const DEBUG = window.location.hostname === "localhost";

export const RANDOM_SEED = 4;

export const calendar: AdventCalendarEntry[] = [
  {
    door: 1,
    image: img_santa_015,
    title: "Klangio XMAS Playlist",
    content: (
      <div style={{ width: 500, maxWidth: "100%" }}>
        <Typography style={{ fontSize: 16 }}>
          We asked the whole office and created a playlist of our favorite Christmas songs. We hope it gets you in the Christmas spirit!
        </Typography>
        <br />
        <iframe
          title='Klangio XMAS Playlist on Spotify'
          style={{ borderRadius: "12px" }}
          src="https://open.spotify.com/embed/playlist/4kOUlzPyOZmp7savcmfBU2?utm_source=generator&theme=1"
          width="100%" height="380" frameBorder="0" allowFullScreen={false}
          allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy"
        ></iframe>
      </div>
    ),
    cta: (
      <Button target="_blank" href="https://open.spotify.com/playlist/4kOUlzPyOZmp7savcmfBU2?si=496a0f51c23b4147" color="inherit" style={{
        color: "#fff",
        fontSize: 16,
      }}>
        Go to Playlist
      </Button >
    ),
  },
  {
    door: 2,
    image: img_santa_010,
    title: "Free Day Piano2Notes",
    content: (
      <div style={{ width: 500, maxWidth: "100%" }}>
        <Typography style={{ fontSize: 16 }}>
          Only <b>today</b>, you can get full transcriptions in Piano2Notes completely for free!
        </Typography>
        <br />
        <img
          alt='p2n screenshot'
          src={img_p2n_screenshot}
          style={{
            width: "100%"
          }}
        />
        <br /><br />
        To get your free transcription use the coupon code <b>"FREEDAY"</b> in the checkout.
      </div>
    ),
    cta: (
      <Button target="_blank" href="https://klang.io/piano2notes" color="inherit" style={{
        color: "#fff",
        fontSize: 16,
      }}>
        Go to Piano2Notes
      </Button >
    ),
  },
  {
    door: 3,
    image: img_santa_012,
    title: "Piano2Notes Discount Code",
    content: (
      <div style={{ width: 500, maxWidth: "100%" }}>
        <Typography style={{ fontSize: 16 }}>
          Save 20% on your next purchase on Piano2Notes.
        </Typography>
        <br />
        <CouponCode logo={p2n_icon} product="piano2notes" amount="20%" code="PIANOXMAS23" />
      </div>
    ),
    cta: (
      <Button target="_blank" href="https://klang.io/piano2notes" color="inherit" style={{
        color: "#fff",
        fontSize: 16,
      }}>
        Go to Piano2Notes
      </Button >
    ),
  },
  {
    door: 4,
    image: img_santa_027,
    title: "Gift Cards Are Available",
    content: (
      <div style={{ width: 500, maxWidth: "100%" }}>
        <Typography style={{ fontSize: 16 }}>
          🎁 Gift Cards are now available 🎁 Door 4 of the Klangio Advent Calendar 📅: Presenting the perfect gift for any musician wanting to turn their music into notes. No subscription required!
        </Typography>
        <br />
        <img
          alt='klangio gift cards available'
          src={img_giftcards_1}
          style={{
            width: "100%"
          }}
        />
      </div>
    ),
    cta: (
      <Button target="_blank" href="https://klang.io/gift-cards/#configurator" color="inherit" style={{
        color: "#fff",
        fontSize: 16,
      }}>
        Explore Klangio Gift Cards
      </Button >
    ),
  },
  // tuesday
  {
    door: 5,
    image: img_santa_011,
    title: "🎶 Turn ANY Song into a Piano Arrangement 🎹",
    content: (
      <div style={{ width: 640, maxWidth: "100%" }}>
        <Typography style={{ fontSize: 16 }}>
          Melody Scanner's Arrangement Mode turns any song into a Piano Arrangement with just a few clicks! And we've created a whole new channel, dedicated to bringing you examples and piano tutorials for recent hits 🎧
        </Typography>
        <br />
        <iframe title="new feature" width="100%" height="360" frameBorder={0}
          src="https://www.youtube.com/embed/zrx-zTeTNxI?enablejsapi=1&origin=https://klang.io"></iframe>
      </div>
    ),
    cta: (
      <Button target="_blank" href="https://www.youtube.com/@PianoTutorialsbyKlangioAI" color="inherit" style={{
        color: "#fff",
        fontSize: 16,
      }}>
        Go to YouTube Channel
      </Button >
    ),
  },
  {
    door: 6,
    image: img_santa_025,
    title: "Gift Card SALE Announcement",
    content: (
      <div style={{ width: 500, maxWidth: "100%" }}>
        <Typography style={{ fontSize: 16 }}>
          🏷️ The X-Mas SALE has begun! 🏷️ Door 6 of the Klangio Advent Calendar 📅:
          Looking for a gift for a musician, or wanna treat yourself with some transcription goodness? 🎧 Gift cards are now down by 15 % until Christmas! No Subscription needed. No Expiration. Sounds like music to your ears 😎
        </Typography>
        <br />
        <img
          alt='nototyp'
          src={img_giftcards_2}
          style={{
            width: "100%"
          }}
        />
      </div>
    ),
    cta: (
      <Button target="_blank" href="https://klang.io/gift-cards/#configurator" color="inherit" style={{
        color: "#fff",
        fontSize: 16,
      }}>
        Get your Discount
      </Button >
    ),
  },
  {
    door: 7,
    image: img_santa_004,
    title: "🎹 Last Christmas Piano Arrangement 🎹",
    content: (
      <div style={{ width: 640, maxWidth: "100%" }}>
        <Typography style={{ fontSize: 16 }}>
          The new Arrangement Mode in Melody Scanner lets you create piano arrangements with just a few clicks. Why not use it to learn the biggest Christmas Hits on the piano?
        </Typography>
        <br />
        <iframe title="new feature" width="100%" height="360" frameBorder={0}
          src="https://www.youtube.com/embed/KC0JLGhu6Ek?enablejsapi=1&origin=https://klang.io"></iframe>
      </div>
    ),
    cta: (
      <Button target="_blank" href="https://www.youtube.com/@PianoTutorialsbyKlangioAI" color="inherit" style={{
        color: "#fff",
        fontSize: 16,
      }}>
        Go to YouTube Channel
      </Button >
    ),
  },
  {
    door: 8,
    image: img_penguin,
    title: "🎹 Christmas Bell Soundfont 🎹",
    content: (
      <div style={{ width: 640, maxWidth: "100%" }}>
        <Typography style={{ fontSize: 16 }}>
          Give your Klangio Transcriptions a bit of christmas magic by playing them back with the new Soundfont we've introduced for these Holidays.
        </Typography>
        <br />
        <img
          alt='christmas bells'
          src={img_bell_soundfont}
          style={{
            width: "100%"
          }}
        />
      </div>
    ),
    cta: (
      <Button target="_blank" href="https://klang.io/piano2notes" color="inherit" style={{
        color: "#fff",
        fontSize: 16,
      }}>
        Open Piano2Notes
      </Button >
    ),
  },
  {
    door: 9,
    image: img_santa_029,
    title: "🎹 Piano Arrangement Tutorial 🎹",
    content: (
      <div style={{ width: 500, maxWidth: "100%" }}>
        <Typography style={{ fontSize: 16 }}>
          Today, Chris will explain you how to create your own Piano Arrangements using the Arrangement Mode of Meldoy Scanner. Learning ANY Songs on the Piano has never been that easy!
        </Typography>
        <br />
        <iframe title="new feature" width="100%" height="360" frameBorder={0}
          src="https://www.youtube.com/embed/Bjw2hNIamMA?enablejsapi=1&origin=https://klang.io"></iframe>
      </div>
    ),
    cta: (
      <Button target="_blank" href="https://melodyscanner.com/" color="inherit" style={{
        color: "#fff",
        fontSize: 16,
      }}>
        Open Melody Scanner
      </Button >
    ),
  },
  {
    door: 10,
    image: img_menorah,
    title: "Melody Scanner Discount Code",
    content: (
      <div style={{ width: 500, maxWidth: "100%" }}>
        <Typography style={{ fontSize: 16 }}>
          Save 20% on your next purchase on www.melodyscanner.com.
        </Typography>
        <br />
        <CouponCode logo={ms_icon} product="Melody Scanner" amount="20%" code="MELODYXMAS23" />
      </div>
    ),
    cta: (
      <Button target="_blank" href="https://melodyscanner.com" color="inherit" style={{
        color: "#fff",
        fontSize: 16,
      }}>
        Go to Melody Scanner
      </Button >
    ),
  },
  {
    door: 11,
    image: img_santa_019,
    title: "🎹 Let it Snow Piano Arrangement 🎹",
    content: (
      <div style={{ width: 640, maxWidth: "100%" }}>
        <Typography style={{ fontSize: 16 }}>
          The new Arrangement Mode in Melody Scanner lets you create piano arrangements with just a few clicks. Why not use it to learn the biggest Christmas Hits on the piano?
        </Typography>
        <br />
        <iframe title="new feature" width="100%" height="360" frameBorder={0}
          src="https://www.youtube.com/embed/RkZ7RH265KY?enablejsapi=1&origin=https://klang.io"></iframe>
      </div>
    ),
    cta: (
      <Button target="_blank" href="https://www.youtube.com/@PianoTutorialsbyKlangioAI" color="inherit" style={{
        color: "#fff",
        fontSize: 16,
      }}>
        Go to YouTube Channel
      </Button >
    ),
  },
  // tuesday
  {
    door: 12,
    image: img_santa_026,
    title: "📣 TAG US AND GET A FREE TRANSCRIPTION 📢",
    content: (
      <div style={{ width: 640, maxWidth: "100%" }}>
        <Typography style={{ fontSize: 16 }}>
          Today we're giving away free transcriptions for everyone tagging our instagram account in their musical posts! Simply add a @klangio to your posts and share the post with us in the dms. Limited to 3 individual posts per account, spamming is excluded ;)
        </Typography>
        <br />
        <img
          alt='share on insta'
          src={img_sharing}
          style={{
            width: "100%"
          }}
        />
      </div>
    ),
    cta: (
      <Button target="_blank" href="https://www.instagram.com/klangio/" color="inherit" style={{
        color: "#fff",
        fontSize: 16,
      }}>
        Klangio on Instagram
      </Button >
    ),
  },
  {
    door: 13,
    image: img_bear,
    title: "🎹 Merry Xmas (War is Over) Arrangement 🎹",
    content: (
      <div style={{ width: 640, maxWidth: "100%" }}>
        <Typography style={{ fontSize: 16 }}>
          The new Arrangement Mode in Melody Scanner lets you create piano arrangements with just a few clicks. Why not use it to learn the biggest Christmas Hits on the piano?
        </Typography>
        <br />
        <iframe title="new feature" width="100%" height="360" frameBorder={0}
          src="https://www.youtube.com/embed/eYZYtIZvsRM?enablejsapi=1&origin=https://klangio.com"></iframe>
      </div>
    ),
    cta: (
      <Button target="_blank" href="https://www.youtube.com/@PianoTutorialsbyKlangioAI" color="inherit" style={{
        color: "#fff",
        fontSize: 16,
      }}>
        Go to YouTube Channel
      </Button >
    ),
  },
  {
    door: 14,
    image: img_santa_018,
    title: "🎹 Lead Sheet Tutorial 🎹",
    content: (
      <div style={{ width: 500, maxWidth: "100%" }}>
        <Typography style={{ fontSize: 16 }}>
          More Melody Scanner Tutorials! Today Chris will explain you how to get the Chords and Melodies from Songs using the Lead Sheet Mode of Melody Scanner, making learning songs on your instrument easy as pie ;)
        </Typography>
        <br />
        <iframe title="new feature" width="100%" height="360" frameBorder={0}
          src="https://www.youtube.com/embed/rOYZig6hmhI?enablejsapi=1&origin=https://klang.io"></iframe>
      </div>
    ),
    cta: (
      <Button target="_blank" href="https://melodyscanner.com/" color="inherit" style={{
        color: "#fff",
        fontSize: 16,
      }}>
        Open Melody Scanner
      </Button >
    ),
  },
  {
    door: 15,
    image: img_ginger_bread_house,
    title: "🥁 DRUM2NOTES BETA LAUNCH 🥁",
    content: (
      <div style={{ width: 640, maxWidth: "100%" }}>
        <Typography style={{ fontSize: 16 }}>
          We're excited to launch the Beta of our new App Drum2Notes today! As the name suggests, its can transcribe recordings of drums in up to 7 different elements within seconds. Give it a try and tell us what you think of this beta version :)
        </Typography>
        <br />
        <img
          alt='drum2notes beta launch'
          src={img_d2n_launch}
          style={{
            width: "100%"
          }}
        />
      </div>
    ),
    cta: (
      <Button target="_blank" href="https://klang.io/drum2notes/" color="inherit" style={{
        color: "#fff",
        fontSize: 16,
      }}>
        Open Drum2Notes
      </Button >
    ),
  },
  {
    door: 16,
    image: img_deer,
    title: "⏰ FREE S2N and G2T Premium Transcription just TODAY ⏰",
    // https://twitter.com/laresonancia/status/627813986390642688
    content: (
      <div style={{ width: 720, maxWidth: "100%" }}>
        <Typography style={{ fontSize: 16 }}>
          Premium features, all download formats and no time-limits for ANY transcriptions of Sing2Notes and Guitar2Tabs.
        </Typography>
        <br />
        <img
          alt='s2n screenshot'
          src={img_s2n_screenshot}
          style={{
            width: "100%"
          }}
        />
        <br /><br />
        To get your free transcription use the coupon code <b>"FREEDAY"</b> in the checkout.
      </div>
    ),
  },
  {
    door: 17,
    image: img_santa_003,
    title: "Sing2Notes & Guitar2Tabs Discount Code",
    content: (
      <div style={{ width: 500, maxWidth: "100%" }}>
        <Typography style={{ fontSize: 16 }}>
          Save 20% on your next purchase on www.guitar2tabs.com and www.sing2notes.com.
        </Typography>
        <br />
        <CouponCode logo={g2t_icon} product="Guitar2Tabs" amount="20%" code="GUITARXMAS23" />
        <br />
        <CouponCode logo={s2n_icon} product="Sing2Notes" amount="20%" code="SINGXMAS23" />
      </div>
    ),
    cta: (
      <Button target="_blank" href="https://sing2notes.com" color="inherit" style={{
        color: "#fff",
        fontSize: 16,
      }}>
        Go to Sing2Notes
      </Button >
    ),
  },
  // tuesday
  {
    door: 18,
    image: img_santa_002,
    title: "🎹 Feliz Navidad Arrangement 🎹",
    content: (
      <div style={{ width: 640, maxWidth: "100%" }}>
        <Typography style={{ fontSize: 16 }}>
          The new Arrangement Mode in Melody Scanner lets you create piano arrangements with just a few clicks. Why not use it to learn the biggest Christmas Hits on the piano?
        </Typography>
        <br />
        <iframe title="new feature" width="100%" height="360" frameBorder={0}
          src="https://www.youtube.com/embed/VgPMXD6jjZ0?enablejsapi=1&origin=https://klangio.com"></iframe>
      </div>
    ),
    cta: (
      <Button target="_blank" href="https://www.youtube.com/@PianoTutorialsbyKlangioAI" color="inherit" style={{
        color: "#fff",
        fontSize: 16,
      }}>
        Go to YouTube Channel
      </Button >
    ),
  },
  {
    door: 19,
    image: img_santa_022,
    title: "📣 TAG US AND GET A FREE TRANSCRIPTION 📢",
    content: (
      <div style={{ width: 500, maxWidth: "100%" }}>
        <Typography style={{ fontSize: 16 }}>
          Once again, we're giving away free transcriptions for everyone tagging our instagram account in their musical posts! Simply add a @klangio to your posts and share the post with us in the dms. Limited to 3 individual posts per account, spamming is excluded ;)
        </Typography>
        <br />
        <img
          alt='sharing special'
          src={img_sharing_2}
          style={{
            width: "100%"
          }}
        />
      </div>
    ),
    cta: (
      <Button target="_blank" href="https://www.instagram.com/klangio/" color="inherit" style={{
        color: "#fff",
        fontSize: 16,
      }}>
        Klangio on Instagram
      </Button >
    ),
  },
  {
    door: 20,
    image: img_santa_022,
    title: "🎹 All I Want For Christmas Arrangement 🎹",
    content: (
      <div style={{ width: 640, maxWidth: "100%" }}>
        <Typography style={{ fontSize: 16 }}>
          The new Arrangement Mode in Melody Scanner lets you create piano arrangements with just a few clicks. Why not use it to learn the biggest Christmas Hits on the piano?
        </Typography>
        <br />
        <iframe title="new feature" width="100%" height="360" frameBorder={0}
          src="https://www.youtube.com/embed/0pL43ogipqE?enablejsapi=1&origin=https://klangio.com"></iframe>
      </div>
    ),
    cta: (
      <Button target="_blank" href="https://www.youtube.com/@PianoTutorialsbyKlangioAI" color="inherit" style={{
        color: "#fff",
        fontSize: 16,
      }}>
        Go to YouTube Channel
      </Button >
    ),
  },
  {
    door: 21,
    image: img_santa_020,
    title: "📊 Number of Klangio Transcriptions 📊",
    content: (
      <div style={{ width: 500, maxWidth: "100%" }}>
        <Typography style={{ fontSize: 16 }}>
          As the year comes to an end, we're looking back at how much you've used our apps to get creative: a whooping 1,210,966 Transcriptions just this year! Thank you so much! You Guys Rock (Literally) 🤩!!!
        </Typography>
        <br />
        <img
          alt='sharing special'
          src={img_21_zahlen}
          style={{
            width: "100%"
          }}
        />
      </div>
    ),
  },
  {
    door: 22,
    image: img_santa_014,
    title: "📊 Monthly Klangio Users 📊",
    content: (
      <div style={{ width: 500, maxWidth: "100%" }}>
        <Typography style={{ fontSize: 16 }}>
          Once again we're recapping this year. This time looking at how many of you have been busy transcribing music each month: 119,627 Monthly Active Users in the last quarter of 2023! Thank you so much, for using our Apps! Looking forward to 2024
        </Typography>
        <br />
        <img
          alt='sharing special'
          src={img_22_zahlen}
          style={{
            width: "100%"
          }}
        />
      </div>
    ),
  },
  {
    door: 23,
    image: img_sock,
    title: "🎁 TOTAL 30% OFF GIFT CARDS SALE 🎁",
    // https://twitter.com/theorangecase/status/654204626808512512
    content: (
      <div style={{ width: 500, maxWidth: "100%" }}>
        <Typography style={{ fontSize: 16 }} align='center'>
          Looking for a Last Minute Present for a musician or a treat for yourself? Get a total 30% OFF Klangio Gift Cards with the Code "GIFTXMAS23" just in time before XMas! No subscription required :)
        </Typography>
        <br />
        <img
          alt='sharing special'
          src={img_23_discount}
          style={{
            width: "100%"
          }}
        />
      </div>
    ),
    cta: (
      <Button target="_blank" href="https://klang.io/gift-cards/#configurator" color="inherit" style={{
        color: "#fff",
        fontSize: 16,
      }}>
        Go to Gift Cards
      </Button >
    ),
  },
  {
    door: 24,
    image: img_santa_021,
    title: "🎁 FREE MONTH OF KLANGIO UNIVERSE🎅",
    content: (
      <div style={{ width: 500, maxWidth: "100%" }}>
        <Typography style={{ fontSize: 16 }} align='center'>
          Merry Christmas! Hope you've been nice, because we've got a gift for you :) <br />You can enjoy a whole month of the Klangio Universe Plan for free! That includes Piano2Notes, Guitar2Tabs and Sing2Notes. Simply use the Code UNIVERSEXMAS23 at the checkout!
        </Typography>
        <br />
        <CouponCode logo={klangio_icon} product="Klangio Universe" amount="100%" code="UNIVERSEXMAS23" />
      </div>
    ),
    cta: (
      <Button target="_blank" href="https://klang.io" color="inherit" style={{
        color: "#fff",
        fontSize: 16,
      }}>
        Go to Klangio
      </Button >
    ),
  },
];